"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectSchema = exports.schemas = void 0;
var normalizr_1 = require("normalizr");
var lodash_1 = require("lodash");
var types_1 = require("../types");
var utils_1 = require("../utils");
var entitySchemas = {};
entitySchemas.team = new normalizr_1.schema.Entity(types_1.App.EntityNames.Teams, {});
entitySchemas.player = new normalizr_1.schema.Entity(types_1.App.EntityNames.Players, {});
entitySchemas.sport = new normalizr_1.schema.Entity(types_1.App.EntityNames.Sports, {});
entitySchemas.slug = new normalizr_1.schema.Entity(types_1.App.EntityNames.Slugs, {});
entitySchemas.meta = new normalizr_1.schema.Entity(types_1.App.EntityNames.Meta, {}, {
    idAttribute: function (value, parent) {
        return utils_1.joinIdPath(parent.id, value.name);
    },
    processStrategy: function (value, parent) {
        return __assign(__assign({}, value), { id: utils_1.joinIdPath(parent.id, value.name) });
    },
});
entitySchemas.tournament = new normalizr_1.schema.Entity(types_1.App.EntityNames.Tournaments, {
    slug: entitySchemas.slug,
}, {
    idAttribute: function (value) { return value.masterId; },
    processStrategy: function (value) {
        return __assign(__assign({}, value), { slug: { id: value.slug, tournamentId: value.id } });
    },
});
entitySchemas.score = new normalizr_1.schema.Entity(types_1.App.EntityNames.Scores, {}, {
    idAttribute: makeDefaultIdPath,
    processStrategy: utils_1.defaultJoinIdPath,
});
entitySchemas.competitor = new normalizr_1.schema.Entity(types_1.App.EntityNames.Competitors, {
    score: new normalizr_1.schema.Array(entitySchemas.score),
}, {
    idAttribute: makeDefaultIdPath,
    processStrategy: utils_1.defaultJoinIdPath,
});
entitySchemas.oddsStatistic = new normalizr_1.schema.Entity(types_1.App.EntityNames.OddsStatistics, {}, {
    idAttribute: makeDefaultIdPath,
    processStrategy: utils_1.defaultJoinIdPath,
});
entitySchemas.oddsStatisticMarkets = new normalizr_1.schema.Entity(types_1.App.EntityNames.BiddingMarkets, {
    odds: new normalizr_1.schema.Array(entitySchemas.oddsStatistic),
}, {
    idAttribute: makeDefaultIdPath,
    processStrategy: utils_1.defaultJoinIdPath,
});
entitySchemas.oddsStatisticBets = new normalizr_1.schema.Entity(types_1.App.EntityNames.OddsStatisticBets, {
    markets: new normalizr_1.schema.Array(entitySchemas.oddsStatisticMarkets),
});
entitySchemas.stream = new normalizr_1.schema.Entity(types_1.App.EntityNames.Streams, {}, {
    idAttribute: makeDefaultIdPath,
    processStrategy: utils_1.defaultJoinIdPath,
});
entitySchemas.odd = new normalizr_1.schema.Entity(types_1.App.EntityNames.Odds, {}, {
    idAttribute: makeDefaultIdPath,
    processStrategy: function (odd, market) {
        var competitorIds = odd.competitorIds, competitorId = odd.competitorId;
        var ids = utils_1.splitMarketPath(market.id);
        if (ids) {
            competitorIds = odd.competitorIds.map(function (cId) {
                return utils_1.joinIdPath(ids.matchId, cId);
            });
            if (competitorId) {
                competitorId = utils_1.joinIdPath(ids.matchId, odd.competitorId);
            }
        }
        return __assign(__assign({}, odd), { competitorId: competitorId,
            competitorIds: competitorIds, id: utils_1.joinIdPath(market.id, odd.id), value: typeof odd.value === 'string' ? +odd.value : odd.value });
    },
});
entitySchemas.market = new normalizr_1.schema.Entity(types_1.App.EntityNames.Markets, {
    odds: new normalizr_1.schema.Array(entitySchemas.odd),
}, {
    idAttribute: makeDefaultIdPath,
    processStrategy: utils_1.defaultJoinIdPath,
});
entitySchemas.betMarket = new normalizr_1.schema.Entity(types_1.App.EntityNames.Markets, {}, {
    idAttribute: function (value, parent) {
        return utils_1.joinIdPath(parent.match.id, value.id);
    },
    processStrategy: function (value, parent) {
        return __assign(__assign({}, value), { id: utils_1.joinIdPath(parent.match.id, value.id) });
    },
});
entitySchemas.freezedOdd = new normalizr_1.schema.Entity(types_1.App.EntityNames.FreezedOdds, {}, {
    idAttribute: function (value, parent) {
        return parent.id;
    },
    processStrategy: function (value, parent) {
        var competitorId = value.competitorId;
        if (competitorId) {
            var matchId = utils_1.getIdsFromBetOddId(parent.id).matchId;
            competitorId = utils_1.joinIdPath(matchId, competitorId);
        }
        return __assign(__assign({}, value), { competitorId: competitorId, competitorIds: value.competitorIds.map(function (compId) {
                return utils_1.joinIdPath(utils_1.getIdsFromBetOddId(parent.id).matchId, compId);
            }), id: parent.id });
    },
});
entitySchemas.match = new normalizr_1.schema.Entity(types_1.App.EntityNames.Matches, {
    markets: new normalizr_1.schema.Array(entitySchemas.market),
    slug: entitySchemas.slug,
    competitors: new normalizr_1.schema.Array(entitySchemas.competitor),
    tournament: entitySchemas.tournament,
    streams: new normalizr_1.schema.Array(entitySchemas.stream),
    meta: new normalizr_1.schema.Array(entitySchemas.meta),
}, {
    processStrategy: function (value) {
        var match = __assign(__assign(__assign({}, lodash_1.omit(value, ['fixture', 'slug'])), value.fixture), { slug: { id: value.slug, matchId: value.id } });
        return match;
    },
});
entitySchemas.betOdd = new normalizr_1.schema.Entity(types_1.App.EntityNames.BetOdds, {
    odd: entitySchemas.freezedOdd,
    market: entitySchemas.betMarket,
    match: entitySchemas.match,
}, {
    idAttribute: function (_a, parent) {
        var match = _a.match, market = _a.market, odd = _a.odd;
        return utils_1.joinIdPath(parent.id, match.id, market.id, odd.id);
    },
    processStrategy: function (value, parent) {
        var odd = value.odd, market = value.market, match = value.match;
        return __assign(__assign({}, value), { id: utils_1.joinIdPath(parent.id, match.id, market.id, odd.id) });
    },
});
entitySchemas.cashOutOrders = new normalizr_1.schema.Entity(types_1.App.EntityNames.CashOutOrders, {}, {
    idAttribute: function (_a) {
        var id = _a.id, betId = _a.betId;
        return utils_1.joinIdPath(betId, id);
    },
    processStrategy: function (value) {
        var id = value.id, betId = value.betId;
        return __assign(__assign({}, value), { id: utils_1.joinIdPath(betId, id) });
    },
});
entitySchemas.bet = new normalizr_1.schema.Entity(types_1.App.EntityNames.Bets, {
    // TODO: "odds" => "betOdds" debug required
    odds: new normalizr_1.schema.Array(entitySchemas.betOdd),
    cashOutOrders: new normalizr_1.schema.Array(entitySchemas.cashOutOrders),
});
entitySchemas.marketTemplates = new normalizr_1.schema.Entity(types_1.App.EntityNames.MarketTemplates, {});
entitySchemas.freebet = new normalizr_1.schema.Entity(types_1.App.EntityNames.Freebets);
exports.schemas = {
    bet: entitySchemas.bet,
    betOdds: entitySchemas.betOdd,
    bets: entitySchemas.bet,
    competitors: entitySchemas.competitor,
    freebets: entitySchemas.freebet,
    freezedOdd: entitySchemas.freezedOdd,
    market: entitySchemas.market,
    marketTemplates: entitySchemas.marketTemplates,
    markets: entitySchemas.market,
    match: entitySchemas.match,
    matches: entitySchemas.match,
    meta: entitySchemas.meta,
    odds: entitySchemas.odd,
    oddsStatistic: entitySchemas.oddsStatistic,
    oddsStatisticBets: entitySchemas.oddsStatisticBets,
    oddsStatisticMarkets: entitySchemas.oddsStatisticMarkets,
    players: entitySchemas.player,
    score: entitySchemas.score,
    slug: entitySchemas.slug,
    sports: entitySchemas.sport,
    streams: entitySchemas.stream,
    teams: entitySchemas.team,
    tournament: entitySchemas.tournament,
    tournaments: entitySchemas.tournament,
    cashOutOrders: entitySchemas.cashOutOrders,
    cashOutOrder: entitySchemas.cashOutOrders,
};
function makeDefaultIdPath(value, parent) {
    return utils_1.joinIdPath(parent.id, value.id);
}
function selectSchema(name, isArraySchema) {
    if (isArraySchema === void 0) { isArraySchema = false; }
    var entitySchema = exports.schemas[name];
    if (!entitySchema) {
        logMissingSchema(name);
        return;
    }
    return isArraySchema ? new normalizr_1.schema.Array(entitySchema) : entitySchema;
}
exports.selectSchema = selectSchema;
function logMissingSchema(name) {
    if (process.env.NODE_ENV === 'production' ||
        [
            'liveOfTheDay',
            'matchOfTheDay',
            'categorizer',
            'bannerZones',
            'banners',
            'topTournaments',
        ].includes(name)) {
        return;
    }
    console.warn('Skip normalization, no schema  found for:', name);
}
//# sourceMappingURL=schema.js.map